const baseUrl = 'https://norma.nomoreparties.space/api';
export const INGRIDIENTS_API = `${baseUrl}/ingredients`;
export const ORDER_API = `${baseUrl}/orders`;
export const RESET_PASSWORD_API = `${baseUrl}/password-reset`;
export const FEED_API_WS = 'wss://norma.nomoreparties.space/orders/all';
export const HISTORY_FEED_API_WS = 'wss://norma.nomoreparties.space/orders';
//------/auth
export const REGISTER_API = `${baseUrl}/auth/register`;
export const LOGIN_API = `${baseUrl}/auth/login`;
export const LOGOUT_API = `${baseUrl}/auth/logout`;
export const REFRESH_TOKEN_API = `${baseUrl}/auth/token`;
//------/user
export const USER_API = `${baseUrl}/auth/user`;

export const BUNS = 'Булки';
export const SAUCES = 'Соусы';
export const MAINS = 'Начинки';

export const SIGN_IN = '/sign-in';
export const SIGN_UP = '/sign-up';
export const FORGOT_PASSWORD = '/forgot-password';
export const PROFILE = '/profile';
export const ORDERS = 'orders';
export const INGREDIENTS = '/ingridients';
export const FEED = '/feed';

export const USER_IS_NOT_EXIST = 'Извините, но такойго пользователя нет в нашей базе. Попробуйте ввести свой email ещё раз'

